// extracted by mini-css-extract-plugin
export var container = "Xsklh";
export var containerDenseless = "CvKRp";
export var containerDenselessNoMargin = "jElSS";
export var containerDenselessNoMargin_Win32Style = "J0wx6";
export var containerDenseless_Win32Style = "yoQXW";
export var fullBleed = "Fr1kM";
export var neutralPaletteBackground = "VJZZC";